import * as React from "react";
import styled, { css, keyframes } from "styled-components";

const Icon = React.forwardRef(function Icon(
  { name, margin = [0, 0, 0, 0], animate = false, title = "", ...rest },
  ref
) {
  return (
    <StyledIcon
      ref={ref}
      className={`icon-${name}`}
      margin={margin}
      animate={animate}
      title={title}
      {...rest}
    />
  );
});

Icon.displayName = "Icon";

const rotate = keyframes`
  to { 
    transform: rotate(360deg);
  }
`;

const StyledIcon = styled.i`
  ${(props) =>
    props.margin &&
    css`
      margin-top: ${props.margin[0]}px;
      margin-right: ${props.margin[1]}px;
      margin-bottom: ${props.margin[2]}px;
      margin-left: ${props.margin[3]}px;
    `}
  ${(props) =>
    props.animate &&
    css`
      animation: ${rotate} 800ms linear infinite;
      display: inline-block;
    `}
`;

export default Icon;
